import {memo} from "react";
import {SectionComponentProps} from "domain/entities";
import QuestionComponent from "./QuestionComponent";
import "../styles/SurveyDesign.css";

const SectionComponent = memo<SectionComponentProps>(
    ({section, answers, onAnswer, isVisible, unansweredIds}) => {
        if (!isVisible) {
            return null;
        }

        return (
            <div className="section-card" data-cy={section.id}>
                <div className="section-header">
                    <h2 className="section-title">{section.title}</h2>
                    <p className="section-description">
                        Por favor, responda a las siguientes preguntas:
                    </p>
                </div>
                {section.questions.map((question) => (
                    <QuestionComponent
                        key={question.id}
                        question={question}
                        answer={answers[question.id]}
                        onAnswer={onAnswer}
                        isUnanswered={unansweredIds.has(question.id)}
                    />
                ))}
            </div>
        );
    },
    (prevProps, nextProps) => {
        if (prevProps.isVisible !== nextProps.isVisible) return false;

        // Si cambió la referencia del Set, vuelve a renderizar
        if (prevProps.unansweredIds !== nextProps.unansweredIds) return false;

        const prevQuestionIds = prevProps.section.questions.map(q => q.id);
        const answersChanged = prevQuestionIds.some(
            id => prevProps.answers[id] !== nextProps.answers[id]
        );

        return !answersChanged;
    }
);

export default SectionComponent;
